module.exports = __webpack_public_path__ + "static/wallet-ledger-c98106b2ff696fbc8c4f96a70a230658.png";